import { UseQueryConfigV2, useQueryV2 } from '@libs/use';
import * as API from '../requests';
import { CASH_QUERY_KEYS } from '../constants';
import { computed, Ref } from 'vue';
import { DirectDebitsItem, InstantDepositQuery } from '@libs/api-reference';

export default function useGetBanksInformationQuery(options: {
  directDebitContract?: Ref<DirectDebitsItem>;
  enabled: Ref<boolean>;
  onSuccess?: UseQueryConfigV2<InstantDepositQuery>['onSuccess'];
}) {
  const {
    result,
    execute: getBanksInformation,
    isPending: isPendingBanksInformation,
  } = useQueryV2(API.getBanksInformation, {
    key: CASH_QUERY_KEYS.banksInformation,
    enabled: options.enabled,
    onSuccess: options.onSuccess,
  });

  const banksInformations = computed(() => {
    const results =
      result.value?.data
        ?.sort((a, b) => a.priority - b.priority)
        ?.filter((item) => item.isActive) || [];

    const directDebit = options.directDebitContract?.value;
    if (directDebit) {
      const filteredResults = results.filter((item) => item);
      return [
        {
          id: directDebit.id,
          ipgId: directDebit.id,
          title: directDebit.bank,
          uId: directDebit.uId,
          isActive: true,
          priority: 0,
          traceId: directDebit.traceId,
          persianTitle: 'پرداخت مستقیم (سامان)',
          directDebits: true,
        },
        ...filteredResults,
      ];
    }
    return results;
  });

  return {
    banksInformations,
    isPendingBanksInformation,
    getBanksInformation,
  };
}
